/*!
 * Nav
 * 메인메뉴 및 사용자 제어 버튼
 */

import {OverlayScrollbars} from 'overlayscrollbars';

export default class Nav {
  TOGGLE_CLASSNAME = 'is-collapsed';

  constructor(element) {
    if (!element) {
      return;
    }
    this.element = element;
    this._init();
  }

  _init() {
    this.togglers = document.querySelectorAll('.sidebar-toggle');
    this.close = document.getElementById('closeSide');
    this.verticalMenu = this.element.querySelector('#menu');

    this.html = document.documentElement;

    this._onCollapseShow = this._onCollapseShow.bind(this);
    this._onCollapseHide = this._onCollapseHide.bind(this);
    this._onCollapseShown = this._onCollapseShown.bind(this);

    this.scrollbar;

    this._initScrollbar();
    this._addVerticalMenu();
    this._addListeners();
  }

  _addListeners() {
    if (this.togglers) {
      this.togglers.forEach((el) => {
        el.addEventListener('click', (event) =>
          this._toggleMobileMenu(event, this.TOGGLE_CLASSNAME),
        );
      });
    }
  }

  // 사이드 메뉴 토글
  _toggleMobileMenu(event, classname) {
    this.html.classList.toggle(classname);
    event.preventDefault();
  }

  // 접힌 메뉴 초기화
  _initCollapsedMenu() {
    let mq_max = parseInt(Globals.xl, 10) - 0.02;
    if (window.matchMedia(`(min-width: ${Globals.md}) and (max-width: ${mq_max}px)`).matches) {
      console.log(mq_max);
      this.html.classList.add(this.TOGGLE_CLASSNAME);
    } else {
      this.html.classList.remove(this.TOGGLE_CLASSNAME);
    }
  }

  // 부트스트랩 callapse 속성 추가
  _addVerticalMenu() {
    const menu = this.verticalMenu;
    menu.querySelectorAll('a').forEach((element) => {
      if (element.nextElementSibling && element.nextElementSibling.tagName === 'UL') {
        element.setAttribute('data-bs-toggle', 'collapse');
        element.setAttribute('data-role', 'button');
        element.setAttribute('aria-expanded', false);
        element.nextElementSibling.classList.add('collapse');
        new bootstrap.Collapse(element.nextElementSibling, {
          toggle: false,
        });
        if (element.getAttribute('data-bs-target')) {
          element.nextElementSibling.setAttribute(
            'id',
            element.getAttribute('data-bs-target').substring(1),
          );
        }
      }
    });

    this._initVerticalMenu();
  }

  // 메뉴 초기화
  _initVerticalMenu() {
    this._addVerticalMenuListeners();
    const menu = this.verticalMenu;
    menu.querySelectorAll('a.active').forEach((element) => {
      if (element.nextElementSibling && element.nextElementSibling.tagName === 'UL') {
        element.setAttribute('data-clicked', true);
        element.setAttribute('aria-expanded', true);
        element.nextElementSibling.classList.add('show');
      }
    });
    this._destroyScrollbar();
    this._initScrollbar('#menuContainer');
  }

  _addVerticalMenuListeners() {
    this._removeVerticalMenuListeners();
    document.querySelectorAll('#menu .collapse').forEach((element) => {
      element.addEventListener('show.bs.collapse', this._onCollapseShow);
    });
    document.querySelectorAll('#menu .collapse').forEach((element) => {
      element.addEventListener('hide.bs.collapse', this._onCollapseHide);
    });
    document.querySelectorAll('#menu .collapse').forEach((element) => {
      element.addEventListener('shown.bs.collapse', this._onCollapseShown);
    });
  }

  _removeVerticalMenuListeners() {
    document.querySelectorAll('#menu .collapse').forEach((element) => {
      element.removeEventListener('show.bs.collapse', this._onCollapseShow);
    });
    document.querySelectorAll('#menu .collapse').forEach((element) => {
      element.removeEventListener('hide.bs.collapse', this._onCollapseHide);
    });
    document.querySelectorAll('#menu .collapse').forEach((element) => {
      element.removeEventListener('shown.bs.collapse', this._onCollapseShown);
    });
  }

  // 하위 메뉴 접기
  _collapseMenu() {
    document.querySelectorAll('#menu > li > a').forEach((element) => {
      if (element.getAttribute('data-clicked') === 'true') {
        const collapse = bootstrap.Collapse.getInstance(element.nextElementSibling);
        if (collapse) {
          collapse.hide();
        }
      }
    });
  }

  // 하위 메뉴 펼치기
  _unCollapseMenu() {
    document.querySelectorAll('#menu > li > a').forEach((element) => {
      if (element.getAttribute('data-clicked') === 'true') {
        const collapse = bootstrap.Collapse.getInstance(element.nextElementSibling);
        if (collapse) {
          collapse.show();
        }
      }
    });
  }

  _onCollapseHide(event) {
    const anchor = event.target.previousElementSibling;
    if (!anchor || anchor.tagName !== 'A') {
      return;
    }
    anchor.setAttribute('aria-expanded', false);
  }

  _onCollapseShow(event) {
    const anchor = event.target.previousElementSibling;
    if (!anchor || anchor.tagName !== 'A') {
      return;
    }
    anchor.setAttribute('aria-expanded', true);
  }

  _onCollapseShown(event) {
    const anchor = event.target.previousElementSibling;
    if (!anchor || anchor.tagName !== 'A') {
      return;
    }
    anchor.setAttribute('data-clicked', true);
  }

  _onVerticalMenuClick(event) {
    const anchor = event.target.closest('a');
    if (!anchor) {
      return;
    }
    if (anchor.getAttribute('data-clicked') === 'true') {
      anchor.removeAttribute('data-clicked');
    }
  }

  // 스크롤바 초기화
  _initScrollbar(selector) {
    if (typeof OverlayScrollbars !== 'undefined') {
      this.scrollbar = OverlayScrollbars(document.querySelector('#menuContainer'), {
        scrollbars: {
          autoHide: 'leave',
          autoHideDelay: 600,
          theme: this._setCustomTheme(),
        },
        overflowBehavior: {x: 'hidden', y: 'scroll'},
      });
    }
  }

  // 스크롤바 해제
  _destroyScrollbar() {
    if (this.scrollbar) {
      this.scrollbar.destroy();
      this.scrollbar = null;
    }
  }

  // Bootstrab 모드 체크
  _setCustomTheme() {
    const selectedTheme = document.querySelector('[data-bs-theme]').value;
    const theme = selectedTheme === 'dark' ? 'os-theme-dark' : 'os-theme-light';
    return theme;
  }
}
